import isColorFilter from './is-color-filter';
import { isNotInventoryFilterColor } from './is-inventory-filter-color';
import { OTHERS_COLOR_FILTER } from './is-others-color-filter';

/**
 * Check if the 'Others' color filter has been selected
 *
 * @param categoryName Category name of the filter
 * @param filter Filter value
 * @param selectedFilters Currently selected filters
 * @returns
 */
export default function hasSelectedOtherColors(
  categoryName: string,
  filter: string,
  selectedFilters: string[]
): boolean {
  if (!isColorFilter(categoryName)) return false;
  if (filter !== OTHERS_COLOR_FILTER) return false;

  return selectedFilters.some(isNotInventoryFilterColor);
}
